<template>
  <div class="infoDiv">
    <div class="h3title">基本信息</div>
    <div class="formbox">
      <el-form class="glo_formBox" label-width="120px">
        <el-form-item label="车次属性:">
          <el-input v-model="dialogFormDispatch.dispatchPropertyShow" disabled placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="配载批次:">
          <el-input v-model="number" disabled placeholder="自动生成" clearable></el-input>
        </el-form-item>
        <el-form-item label="发车日期:" required>
          <el-date-picker v-model="dialogFormDispatch.planDepartureTime" class="input" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="送货计划:">
          <el-select filterable clearable v-model="dialogFormDispatch.startAddrType" placeholder="请选择">
            <el-option v-for="(item, index) in startAddrTypeList" :key="index" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="始发网点:" :required="dialogFormDispatch.startAddrType==1">
          <el-select v-model="dialogFormDispatch.startDeptId" placeholder="请选择" clearable>
            <el-option v-for="item in storageList" :key="item.documentId" :label="item.name" :value="item.documentId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车辆类型:">
          <el-select filterable clearable v-model="dialogFormDispatch.carCategoryConfDictId" placeholder="请选择" @change="changecarCategoryConfDictId">
            <el-option v-for="(item, index) in car_categoryList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否牵引车:">
          <el-select filterable clearable v-model="dialogFormDispatch.isTractor" placeholder="请选择">
            <el-option v-for="(item, index) in isTractorList" :key="index" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车型:">
          <el-select filterable clearable v-model="dialogFormDispatch.carTypeConfDictId" placeholder="请选择">
            <el-option v-for="(item, index)  in car_type_list" :key="index" :label="item.key" :value="item.confDictId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="车牌号码:">
          <el-select filterable clearable allow-create remote v-model="dialogFormDispatch.carNumber" placeholder="请选择">
            <el-option v-for="(item, index) in carNumberList1" :key="index" :label="item.carNumber" :value="item.carNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="挂车号码:">
          <el-select v-model="dialogFormDispatch.trailerNumber" :remote-method="(e) => getcarNumberRmethod(e)" filterable clearable allow-create remote placeholder="请选择">
            <el-option v-for="(item, index) in carNumberList2" :key="index" :label="item.carNumber" :value="item.carNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="司机一:">
          <el-select
            filterable
            clearable
            v-model="dialogFormDispatch.driverOneName"
            placeholder="请选择"
            allow-create
            remote
            :remote-method="
                (val) => runPageReport_down_list_driver('driverList1', val)
              "
            @focus="runPageReport_down_list_driver('driverList1')"
            @change="
                changeDrivers(
                  $event,
                  'driverOneId',
                  'driverOneName',
                  'driverList1',
                  'driverOnePhone',
                  'driverOneIdcard'
                )
              "
          >
            <el-option v-for="(item, index) in driverList1" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="司机一电话:">
          <el-input v-model="dialogFormDispatch.driverOnePhone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="司机一身份证:">
          <el-input v-model="dialogFormDispatch.driverOneIdcard" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="司机二:">
          <el-select
            filterable
            clearable
            v-model="dialogFormDispatch.driverTwoName"
            placeholder="请选择"
            allow-create
            remote
            :remote-method="
                (val) => runPageReport_down_list_driver('driverList2', val)
              "
            @focus="runPageReport_down_list_driver('driverList2')"
            @change="
                changeDrivers(
                  $event,
                  'driverTwoId',
                  'driverTwoName',
                  'driverList2',
                  'driverTwoPhone',
                  'driverTwoIdcard'
                )
              "
          >
            <el-option v-for="(item, index) in driverList2" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机二电话:">
          <el-input v-model="dialogFormDispatch.driverTwoPhone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="司机二身份证:">
          <el-input v-model="dialogFormDispatch.driverTwoIdcard" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="押运员一:">
          <el-select
            v-model="dialogFormDispatch.supercargoOneName"
            placeholder="请选择"
            filterable
            clearable
            allow-create
            remote
            :remote-method="
                (val) => runPageReport_down_list_driver('driverList3', val)
              "
            @focus="runPageReport_down_list_driver('driverList3')"
            @change="
                changeDrivers(
                  $event,
                  'supercargoOneId',
                  'supercargoOneName',
                  'driverList3'
                )
              "
          >
            <el-option v-for="(item, index) in driverList3" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="押运员二:">
          <el-select
            v-model="dialogFormDispatch.supercargoTwoName"
            placeholder="请选择"
            filterable
            clearable
            allow-create
            remote
            :remote-method="
                (val) => runPageReport_down_list_driver('driverList4', val)
              "
            @focus="runPageReport_down_list_driver('driverList4')"
            @change="
                changeDrivers(
                  $event,
                  'supercargoTwoId',
                  'supercargoTwoName',
                  'driverList4'
                )
              "
          >
            <el-option v-for="(item, index) in driverList4" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="随车人员一:">
          <el-select
            v-model="dialogFormDispatch.carFollowPersonnelOneName"
            placeholder="请选择"
            clearable
            remote
            filterable
            :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList');
                }
              "
            @focus="focusMethod('employee', 'employeeList')"
            @clear="remoteMethod('', 'employee', 'employeeList')"
          >
            <el-option v-for="(item, index) in employeeList" :key="index" :label="item.name" :value="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="随车人员二:">
          <el-select
            v-model="dialogFormDispatch.carFollowPersonnelTwoName"
            placeholder="请选择"
            clearable
            remote
            filterable
            :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList2');
                }
              "
            @focus="focusMethod('employee', 'employeeList2')"
            @clear="remoteMethod('', 'employee', 'employeeList2')"
          >
            <el-option v-for="(item, index) in employeeList2" :key="index" :label="item.name" :value="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="发货员一:">
          <el-select
            v-model="employeeName1"
            placeholder="请选择"
            clearable
            remote
            filterable
            :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList3');
                }
              "
            @focus="focusMethod('employee', 'employeeList3')"
            @clear="remoteMethod('', 'employee', 'employeeList3')"
          >
            <el-option v-for="(item, index) in employeeList3" :key="index" :label="item.name" :value="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="发货员二:">
          <el-select
            v-model="employeeName2"
            placeholder="请选择"
            clearable
            remote
            filterable
            :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList4');
                }
              "
            @focus="focusMethod('employee', 'employeeList4')"
            @clear="remoteMethod('', 'employee', 'employeeList4')"
          >
            <el-option v-for="(item, index) in employeeList4" :key="index" :label="item.name" :value="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="发车合同号:">
          <el-input v-model="dialogFormDispatch.dispatchContractNumber" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="应付合计:">
          <el-input v-model="dialogFormDispatch.totalAmount" placeholder="请输入" clearable type="number"></el-input>
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="备注:">
          <el-input type="textarea" v-model="dialogFormDispatch.remarks"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="h3title">运单明细</div>
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems" @click="clickAdd">单票添加</el-button>
        <el-button class="glo_btnItems" @click="clickRetrieve">取出明细</el-button>
        <el-button class="glo_btnItems" @click="clickDel">移除</el-button>
        <el-button class="glo_btnItems" @click="clickCostSharing">费用均摊</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <!-- :summary-method="getSummaries" -->
      <el-table header-align="center" ref="mytable" :data="tableData1" @selection-change="handleSelectionChange1" show-summary>
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <el-table-column label="费用摊分" width="200" prop="amount">
          <template slot-scope="scope">
            <el-input v-model="tableData1[scope.$index].amount" placeholder="请输入" filterable></el-input>
          </template>
        </el-table-column>
        <template v-for="(item, index) in myTableHeard4">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
      </el-table>
    </div>
    <!-- 单票添加 -->
    <myDialog :diaWidth="diaWidth2" :dialogTitle="dialogTitle2" :isShowDialog="isShowDialog2" @handleCloseDia="handleCloseDia2" @diaCancelBtn="handleCloseDia2" @diaConfirmBtn="diaConfirmBtn2">
      <div class="formbox" v-if="isShowDialog2">
        <el-form class="glo_formBox" label-width="110px">
          <el-form-item label="运单号:" style="width:100%;">
            <!-- <el-input v-model="dialogForm2.waybillNumber" placeholder="请输入"></el-input> -->
            <el-select
              v-model="dialogForm2.waybillNumber"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod_runPageReport(e);
                }
              "
              @focus="focusMetho_runPageReport()"
              @clear="remoteMethod_runPageReport('')"
            >
              <el-option v-for="(item, index) in waybillNumberList" :key="index" :label="item.waybillNumber" :value="item.waybillNumber" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 费用均摊 -->
    <myDialog :diaWidth="diaWidth1" :dialogTitle="dialogTitle1" :isShowDialog="isShowDialog1" @handleCloseDia="handleCloseDia1" @diaCancelBtn="handleCloseDia1" @diaConfirmBtn="diaConfirmBtn1">
      <div class="formbox" v-if="isShowDialog1">
        <el-form class="glo_formBox" label-width="110px">
          <el-form-item label="计费方式:" style="width:100%;">
            <el-select v-model="dialogForm1.formulaBillingWeightId" placeholder="请输入" clearable>
              <el-option v-for="item in out_going_billing_method_list" :key="item.formulaBillingWeightId+''" :label="item.formulaBillingWeightName" :value="item.formulaBillingWeightId+''"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 外发取出明细 -->
    <myDialog :diaWidth="diaWidth4" :dialogTitle="dialogTitle4" :isShowDialog="isShowDialog4" @handleCloseDia="handleCloseDia4" @diaCancelBtn="handleCloseDia4" @diaConfirmBtn="diaConfirmBtn4">
      <div class="glo_dialogForm" v-if="isShowDialog4">
        <!-- 查询条件 -->
        <div class="btnsform">
          <queryCondition ref="queryForm" :More="isHaseMore" :formConfig="queryCondditionDatas"></queryCondition>
          <el-button class="glo_btnItems glo_bgcMainColor" @click="clickQuery4">查询</el-button>
        </div>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table header-align="center" ref="mytable4" @row-click="rowclick4" :data="tableData4" border stripe :highlight-current-row="true" @selection-change="handleSelectionChange4">
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
            <template v-for="(item, index) in myTableHeard4">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import queryCondition from "@/components/queryCondition.vue";
import _ from "lodash";
export default {
  inject: ["reload"],
  components: {
    myDialog,
    queryCondition,
  },
  props: {
    dispatchId: {
      typeof: String,
      default: "",
    },
  },
  data() {
    return {
      waybillNumberList: [],
      tableData1: [],
      //配载明细
      myTableHeard4: [],
      selectTableData1: [],
      pageStart: 1,
      pageTotal: 100,

      dialogFormDispatch: {
        dispatchPropertyShow: "",
        planDepartureTime: this.$TOOLS.getCurrentDate(),
        startAddrType: 1,
        startDeptId: "",
        carCategoryConfDictId: "",
        isTractor: 0,
        carTypeConfDictId: "",
        carNumber: "",
        trailerNumber: "",
        driverOneId: "",
        driverOnePhone: "",
        driverOneIdcard: "",
        driverTwoId: "",
        driverTwoPhone: "",
        driverTwoIdcard: "",
        supercargoOneId: "",
        supercargoTwoId: "",
        carFollowPersonnelOneName: "",
        carFollowPersonnelTwoName: "",
        dispatchContractNumber: "",
        totalAmount: "",
        remarks: "",
      },
      driverList: [], //司机列表
      driverList1: [], //司机列表
      driverList2: [], //司机列表
      driverList3: [], //司机列表
      driverList4: [], //司机列表
      car_categoryList: [], //车辆分类
      carNumberList1: [], //车牌号码
      carNumberList2: [], //挂车号码
      car_type_list: [], //车型
      storageList: [],
      isTractorList: [
        //是否牵引车
        { val: 0, name: "否" },
        { val: 1, name: "是" },
      ],
      employeeList: [],
      employeeList2: [],
      employeeList3: [],
      employeeList4: [],
      employeeName1: "",
      employeeName2: "",

      isShowDialog1: false,
      dialogTitle1: "费用均摊",
      diaWidth1: "520px",
      dialogForm1: {
        formulaBillingWeightId: "",
      },
      out_going_billing_method_list: [],

      isShowDialog2: false,
      dialogTitle2: "单票添加运单",
      diaWidth2: "520px",
      dialogForm2: {
        waybillNumber: "",
      },

      isShowDialog4: false,
      dialogTitle4: "外发取出明细",
      diaWidth4: "90%",
      tableData4: [],
      myTableHeard4: [],
      selectTableData4: [], //收发地址 表格选择
      pageGroupName: "DispatchCar_OutgoingDispatch", //  页面标识
      reportFiledsNumber: "admin_waifa_dispatch_list", // 动态 条件、表头
      queryCondditionDatas: [],
      originalTabelHeadeTitle: [],
      tabelHeadeTitle: [],
      isHaseMore: true, //false == 更多条件  true ==收起条件

      initIds: [],
      tableData1_1: [],
      number: "",
      totalArr: [
        "amount",
        "planTakeFee",
        "planSendFee",
        "totalCount",
        "totalNetWeight",
        "totalGrossWeight",
        "totalVolume",
        "sendFee",
        "billingAmount",
        "totalFreight",
        "planFreight",
        "planOtherFee",
        "planTotalAmount",
        "basicFreight",
        "taksCount",
        "financeOutAmount",
        "totalWeight",
      ],
      startAddrTypeList: [
        { val: 1, name: "仓配送货" },
        { val: 2, name: "提货直送" },
      ],
    };
  },
  watch: {
    dispatchId(a, b) {
      if (a) {
        this.getDispatchDetailApi();
      }
    },
  },
  created() {},
  mounted() {
    this.getConfDictValDownLists("car_type");
    this.getConfDictValDownLists("car_category");
    this.getObjectUserDownList("driver");
    this.getObjectUserDownList("storage"); //网点
    this.getcarNumberRmethod("");
    this.runPageReportDetailsitemId("formula_billing_weight_down_list");
    this.initTable();
    this.$nextTick(() => {
      this.getDispatchDetailApi();
    });
  },
  // activated() {
  //   this.$nextTick(() => {
  //     this.getDispatchDetailApi();
  //   });
  // },
  destroyed() {},
  methods: {
    runPageReport_down_list_driver(key, e) {
      this.$API
        .runPageReport({
          conditionReqs: [
            {
              conditonKey: "name",
              conditonVal: e,
            },
          ],
          number: "down_list_driver",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this[key] = res.data.result.datas.data || [];
        });
    },
    // 选择司机/押运
    changeDrivers(e, id, name, listkey, phone, card) {
      this.dialogFormDispatch[id] = "";
      this.dialogFormDispatch[name] = "";
      this.dialogFormDispatch[phone] = "";
      this.dialogFormDispatch[card] = "";
      if (e) {
        this.dialogFormDispatch[name] = e;
        this[listkey].forEach((item) => {
          if (item.name == e) {
            this.dialogFormDispatch[id] = item.id || "";
            if (phone) {
              this.dialogFormDispatch[phone] = item.phone || "";
            }
            if (card) {
              this.dialogFormDispatch[card] = item.idCard || "";
            }
          }
        });
      }
    },
    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        if (this.totalArr.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return this.$TOOLS.mathToFixed(this.$TOOLS.add(prev, curr), 2);
              } else {
                return prev;
              }
            }, 0);
            sums[index] += "";
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    // 动态接口获取下拉列表
    runPageReportDetailsitemId(number, array) {
      // customer_channel_down_list => 客户报价方式下拉列表
      // 参数key:
      // customerId(客户id 必填)
      // channelName(报价方式名称 非必填)

      // customer_dispatch_channel_down_list => 客户线路报价下拉列表(报价到货区域)
      // 参数key:
      // channelId(报价方式id 必填)
      // offerName(线路报价名称 非必填)

      // formula_billing_weight_down_list => 获取计费取值公式下拉列表

      this.$API
        .runPageReportDetails({
          number: number,
          conditionReqs: array || [],
        })
        .then((res) => {
          let datas = res.data.result.datas || [];
          if (number == "formula_billing_weight_down_list") {
            // 计费方式
            this.out_going_billing_method_list = datas;
          }
        });
    },
    // 提交
    async submit(saveType) {
      this.dialogFormDispatch.dispatchId = this.dispatchId;
      this.dialogFormDispatch.saveType = saveType;
      let curs3 = this.employeeList3.filter(
        (item) => item.name == this.employeeName1
      );
      let curs4 = this.employeeList4.filter(
        (item) => item.name == this.employeeName2
      );
      this.dialogFormDispatch.notifierReqs = [
        {
          employeeId: (curs3.length && curs3[0].documentId) || "",
          employeeName: this.employeeName1,
          employeeType: "zi_you:employee_type",
          sort: 0,
        },
        {
          employeeId: (curs4.length && curs4[0].documentId) || "",
          employeeName: this.employeeName2,
          employeeType: "zi_you:employee_type",
          sort: 1,
        },
      ];
      let orderIds = [];
      this.tableData1.forEach((element, index) => {
        let operationType = "ADD";
        if (this.initIds.includes(element.waybillDispatchId)) {
          operationType = "UPDATE";
        }
        orderIds.push({
          operationType,
          amount: element.amount || 0,
          waybillDispatchId: element.waybillDispatchId,
          sort: index,
        });
      });
      let arrsgg = [];
      this.tableData1_1.forEach((element,index) => {
        if (
          !orderIds.find((n) => {
            return n.waybillDispatchId == element.waybillDispatchId;
          })
        ) {
          arrsgg.push({
            waybillDispatchId: element.waybillDispatchId,
            sort: orderIds.length + index,
            operationType: "DEL",
          });
        }
      });
      this.dialogFormDispatch.orderIds = [...orderIds, ...arrsgg];
      await this.$API
        .updateWaifaDispatch(this.dialogFormDispatch)
        .then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message || "操作成功");
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/DispatchCar/VehicleStowage",
              query: {
                isreload: "isreload",
              },
            });
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },

    getDispatchDetailApi() {
      this.$API
        .getDispatchDetail({ dispatchId: this.dispatchId })
        .then((res) => {
          let datas = res.data.result[0] || {};
          this.number = datas.number;
          this.dialogFormDispatch = {
            startAddrType: datas.startAddrType || 1,
            dispatchPropertyShow: datas.dispatchPropertyShow || "",
            planDepartureTime: datas.planDepartureTime || "",
            startDeptId: datas.startDeptId || "",
            carCategoryConfDictId: datas.carCategoryConfDictId || "",
            carTypeConfDictId: datas.carTypeConfDictId || "",
            isTractor: datas.isTractor || 0,
            carNumber: datas.carNumber || "",
            trailerNumber: datas.trailerNumber || "",
            driverOneId: datas.driverOneId || "",
            driverOneIdcard: datas.driverOneIdcard || "",
            driverOneName: datas.driverOneName || "",
            driverOnePhone: datas.driverOnePhone || "",
            driverTwoId: datas.driverTwoId || "",
            driverTwoIdcard: datas.driverTwoIdcard || "",
            driverTwoName: datas.driverTwoName || "",
            driverTwoPhone: datas.driverTwoPhone || "",
            supercargoOneId: datas.supercargoOneId || "",
            supercargoOneName: datas.supercargoOneName || "",
            supercargoTwoId: datas.supercargoTwoId || "",
            supercargoTwoName: datas.supercargoTwoName || "",
            carFollowPersonnelOneId: datas.carFollowPersonnelOneId || "",
            carFollowPersonnelOneName: datas.carFollowPersonnelOneName || "",
            carFollowPersonnelTwoId: datas.carFollowPersonnelTwoId || "",
            carFollowPersonnelTwoName: datas.carFollowPersonnelTwoName || "",
            dispatchContractNumber: datas.dispatchContractNumber || "",
            totalAmount: datas.totalAmount || "",
            remarks: datas.remarks || "",
          };
          this.employeeName1 =
            (datas.notifierReqs &&
              datas.notifierReqs.length &&
              datas.notifierReqs[0].employeeName) ||
            "";
          this.employeeName2 =
            (datas.notifierReqs &&
              datas.notifierReqs.length > 1 &&
              datas.notifierReqs[1].employeeName) ||
            "";
          this.tableData1 = datas.orderIds || [];
          this.tableData1_1 = JSON.parse(JSON.stringify(datas.orderIds || []));
          this.initIds = this.tableData1.map((n) => {
            return n.waybillDispatchId;
          });
          this.changecarCategoryConfDictId(
            this.dialogFormDispatch.carCategoryConfDictId
          );
        });
    },
    handleSelectionChange1(e) {
      this.selectTableData1 = e;
    },
    clickAdd() {
      this.isShowDialog2 = true;
    },
    async clickRetrieve() {
      this.isShowDialog4 = true;
      setTimeout(() => {
        this.clickQuery4();
      }, 0);
    },
    clickDel() {
      if (this.tableData1.length < 1) {
        this.$message.warning("配载明细至少留一条");
        return false;
      }
      if (this.selectTableData1.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      let ids = [];
      this.selectTableData1.forEach((item) => {
        ids.push(item.waybillDispatchId);
      });
      let keyset = "waybillDispatchId";
      let deleteIndex = [];
      this.tableData1.filter((item, index) => {
        if (
          this.selectTableData1
            .map((n) => {
              return n[keyset];
            })
            .includes(item[keyset])
        ) {
          deleteIndex.push(index);
        }
      });
      if (deleteIndex.length > 0) {
        for (let i = deleteIndex.length - 1; i >= 0; i--) {
          this.tableData1.splice(deleteIndex[i], 1);
        }
      }
    },
    clickCostSharing() {
      if (!this.dialogFormDispatch.totalAmount) {
        this.$message.warning("请输入预计费用");
        return false;
      }
      if (!this.tableData1.length) {
        this.$message.warning("请选择运单明细");
        return false;
      }
      this.isShowDialog1 = true;
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {
        formulaBillingWeightId: "",
      };
    },
    //  弹窗确认保存事件
    async diaConfirmBtn1() {
      let { totalAmount } = this.dialogFormDispatch;
      let arrs = [];
      let tables = _.cloneDeep(this.tableData1);
      const promisemap = tables.map(async (element, index) => {
        let objj = await this.billWeightCalculationById(index);
        arrs.push(objj);
      });
      await Promise.all(promisemap);
      let sums = this.sumpubGGG(arrs, "value", 0);
      arrs.forEach((element) => {
        let getbasicFreight = this.$TOOLS.mathToFixed(
          this.$TOOLS.mul(this.$TOOLS.divide(element.value, sums), totalAmount)
        );
        tables[element.key].amount = getbasicFreight;
      });
      this.tableData1 = tables;
      this.isShowDialog1 = false;
    },
    // 运费计算(自定义选择报价)
    async billWeightCalculationById(index) {
      let grossWeight = this.curBillingSums("grossWeight", index);
      let netWeight = this.curBillingSums("netWeight", index);
      let packageCount = this.curBillingSums("packageCount", index);
      let volume = this.curBillingSums("volume", index);
      let param = {
        formulaBillingWeightId: this.dialogForm1.formulaBillingWeightId,
        grossWeight: grossWeight || 0,
        netWeight: netWeight || 0,
        packageCount: packageCount || 0,
        volume: volume || 0,
      };
      return this.$API.billWeightCalculationById(param).then((res) => {
        let datas = res.data.result || {};
        return {
          key: index,
          value: Number(datas.billingWeight) || 0,
        };
      });
    },
    curBillingSums(key, index) {
      // 计算 运费均摊
      return this.tableData1[index][key];
    },
    sumpubGGG(arr, key, tofid = 2) {
      return arr
        .map((n) => {
          return n[key];
        })
        .reduce((prev, curr) => this.$TOOLS.add(prev, curr));
    },
    // //  弹窗确认保存事件
    // diaConfirmBtn1() {
    //   let { totalAmount } = this.dialogFormDispatch;
    //   let cursBillingId = this.dialogForm1.formulaBillingWeightId;
    //   let curBilling = this.out_going_billing_method_list.filter((n) => {
    //     return n.confDictId == cursBillingId;
    //   })[0].key;
    //   switch (curBilling) {
    //     case "按票数":
    //       let arrs = _.cloneDeep(this.tableData1);
    //       let cursend = this.$TOOLS.divide(totalAmount, arrs.length).toFixed(2);
    //       arrs.forEach((element) => {
    //         element.amount = cursend;
    //       });
    //       this.tableData1 = arrs;
    //       break;
    //     case "按件数":
    //       this.curBillingSums("packageCount");
    //       break;
    //     case "按毛重":
    //       this.curBillingSums("grossWeight");
    //       break;
    //     case "按净重":
    //       this.curBillingSums("netWeight");
    //       break;
    //     case "按体积":
    //       this.curBillingSums("volume");
    //       break;
    //     default:
    //       break;
    //   }
    //   this.isShowDialog1 = false;
    // },
    // sumpub(arr, key, tofid = 2) {
    //   return this.$TOOLS.mathToFixed(
    //     arr
    //       .map((n) => {
    //         return n[key] || 0;
    //       })
    //       .reduce((prev, curr) => this.$TOOLS.add(prev, curr)),
    //     tofid
    //   );
    // },
    // curBillingSums(key) {
    //   // 计算 运费均摊
    //   let { totalAmount } = this.dialogFormDispatch;
    //   let arrs = _.cloneDeep(this.tableData1);
    //   let sum = this.sumpub(arrs, key, 0);
    //   arrs.forEach((element, index) => {
    //     let al =
    //       element[key] == 0
    //         ? ""
    //         : this.$TOOLS.mathToFixed(
    //             this.$TOOLS.mul(
    //               this.$TOOLS.divide(element[key], sum),
    //               totalAmount
    //             )
    //           );
    //     element.amount = al;
    //     // element.amount = isNaN(al) ? 0 : al;
    //   });
    //   this.tableData1 = arrs;
    //   this.$message.success("自动均摊成功");
    // },
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        waybillNumber: "",
      };
      this.waybillNumberList = [];
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      let { waybillNumber } = this.dialogForm2;
      if (!waybillNumber) {
        this.$message.warning("请输入运单号");
        return false;
      }
      let params = {
        conditionReqs: [
          {
            conditonKey: "waybillNumber",
            conditonVal: waybillNumber,
          },
        ],
        pageStart: 1,
        pageTotal: 100,
        number: this.reportFiledsNumber,
      };
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result.datas.data || [];
          if (datas.length) {
            let cursnum = datas[0].waybillNumber;
            if (
              this.tableData1
                .map((n) => {
                  return n.waybillNumber;
                })
                .includes(cursnum)
            ) {
              this.$message.error(`运单 ${cursnum} 添加重复，请输入新的运单号`);
              return false;
            }
            this.tableData1.push(datas[0]);
            this.isShowDialog2 = false;
          } else {
            this.$message.error(`没有查询到运单 ${cursnum} `);
          }
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
      // this.$API
      //   .waybillzhiSong({
      //     remarks,
      //   })
      //   .then((res) => {
      //     this.$message.success(res.data.message || "操作成功");
      //     this.isShowDialog2 = false;
      //     this.getData();
      //   });
    },
    focusMetho_runPageReport(key, keys) {
      if (this.waybillNumberList.length == 0) {
        this.remoteMethod_runPageReport("");
      }
    },
    remoteMethod_runPageReport(name) {
      let params = {
        conditionReqs: [
          {
            conditonKey: "waybillNumber",
            conditonVal: name,
          },
        ],
        pageStart: 1,
        pageTotal: 20,
        number: this.reportFiledsNumber,
      };
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          this.waybillNumberList = res.data.result.datas.data || [];
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    // 外发——————————
    arrayFilter(arr, key) {
      return arr.filter((item, index, self) => {
        // 利用findIndex方法找到第一个与当前元素id相等的元素索引
        const i = self.findIndex((t) => t[key] === item[key]);
        // 如果当前索引等于当前元素在self中的最初出现位置索引，则表示元素符合要求，不是重复元素，保留
        return i === index;
      });
    },
    //取出明细
    handleCloseDia4() {
      this.isShowDialog4 = false;
    },
    //取出明细  弹窗确认保存事件
    diaConfirmBtn4() {
      // 添加费项
      if (!this.selectTableData4.length) {
        this.$message.error(`请选择操作数据`);
        return false;
      }
      this.tableData1 = this.arrayFilter(
        [...this.selectTableData4, ...this.tableData1],
        "waybillNumber"
      );
      this.isShowDialog4 = false;
    },
    //取出明细 点击选中当前行
    rowclick4(row, event, column) {
      this.$refs.mytable4.toggleRowSelection(row);
    },
    //取出明细 表格选择事件
    handleSelectionChange4(e) {
      this.selectTableData4 = e;
    },
    clickQuery4() {
      this.getData();
    },

    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      return this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
        });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownLists(dictType) {
      this.$COMAPI.getConfDictValDownList(dictType).then((res) => {
        //车辆分类
        if (dictType == "car_category") {
          this.car_categoryList = res || [];
        }
        if (dictType == "car_type") {
          // 车型
          this.car_type_list = res || [];
        }
      });
    },
    // 获取车辆下拉列表(拿车牌号码)
    changecarCategoryConfDictId(e) {
      if (e) {
        this.$API
          .CarDownList({
            pageStart: 1,
            pageTotal: 200,
            carNumber: "",
            carCategoryConfDictId: e, //车辆分类id
          })
          .then((res) => {
            this.carNumberList1 = res.data.result.data || [];
          });
      }
    },
    // 获取车辆下拉列表(拿挂车号码)
    getcarNumberRmethod(e) {
      this.$API
        .CarArchiveList({
          pageStart: 1,
          pageTotal: 200,
          carNumber: e || "",
        })
        .then((res) => {
          this.carNumberList2 = res.data.result.data || [];
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "driver") {
          this.driverList = res || [];
        }
        if (key == "storage") {
          //获取网点列表
          this.storageList = res || [];
        }
      });
    },

    getData() {
      let conditionReqs = [];
      let F_config = this.$refs.queryForm.F_config;
      F_config.forEach((element) => {
        let {
          textBoxType,
          conditonKey,
          dropdownSubmitField,
          conditonVal,
          timeType,
          timeChilds,
          startTime_a,
          endTime_a,
        } = element;
        switch (textBoxType) {
          case "input":
            conditionReqs.push({
              conditonKey,
              conditonVal,
            });
            break;
          case "select":
            conditionReqs.push({
              conditonKey: dropdownSubmitField || conditonKey,
              conditonVal,
            });
            break;
          case "datetime":
            let curs = timeChilds[timeType];
            curs &&
              curs.children.forEach((element, index) => {
                console.log(element);
                conditionReqs.push({
                  conditonKey: element.conditonKey,
                  conditonVal:
                    index == 1
                      ? `${endTime_a} 23:59:59`
                      : `${startTime_a} 00:00:00`,
                });
              });
            break;
          default:
            break;
        }
      });
      let params = {
        conditionReqs,
        pageStart: 1,
        pageTotal: 100,
        number: this.reportFiledsNumber,
      };
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result.datas || {};
          this.tableData4 = datas.data || [];
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },
    async initTable() {
      //获取 所有页面 number
      await this.$API
        .getQueryList({
          number: "",
          reportName: "",
        })
        .then((res) => {});
      //获取当前页面已设置表头
      await this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              this.tabelHeadeTitle = JSON.parse(arr[0].sortObject);
            }
          }
        });
      //表格 表头默认
      await this.$API
        .getReportFileds({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          let lists = [];
          datas.forEach((element) => {
            lists.push({
              name: element.fieldNameShow,
              field: element.fieldAlias,
              width: element.wide,
              isTotal: element.isSum,
              sort: element.sort,
              isShow: element.isshow == 0 ? false : true,
              isSort: true,
            });
          });
          this.originalTabelHeadeTitle = lists;
          if (!this.tabelHeadeTitle.length) {
            this.tabelHeadeTitle = this.originalTabelHeadeTitle;
          }
        });
      this.myTableHeard4 = this.tabelHeadeTitle;

      let arrsConddition = [];
      // 获取查询条件 list
      await this.$API
        .getReportConditions({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          if (datas && datas.length > 0) {
            datas.map((n) => (n.conditonVal = n.conditonVal || ""));
            let arrs = datas.filter((n) => {
              return n.textBoxType === "datetime";
            });
            let timeobjs = {};
            arrs.forEach((item) => {
              let { sort, conditonKeyShow } = item;
              let name = conditonKeyShow.includes("起始")
                ? conditonKeyShow.split("起始").join("")
                : conditonKeyShow.split("结束").join("");
              if (!timeobjs[sort]) {
                timeobjs[sort] = {
                  sort,
                  name,
                  children: [],
                };
              }
              timeobjs[sort].children.push(item);
            });
            let gdates = [];
            let dates = Object.values(timeobjs);
            if (dates.length) {
              console.log(dates);
              gdates = [
                {
                  textBoxType: "datetime",
                  startTime_a: this.$TOOLS.getFlexDate(this.$COMMON.timeNum),
                  endTime_a: this.$TOOLS.getCurrentDate(),
                  timeType: "0",
                  timeTypes: dates.map((n, i) => {
                    return { value: String(i), label: n.name };
                  }),
                  timeChilds: dates.map((n, i) => {
                    return { sort: n.sort, name: n.name, children: n.children };
                  }),
                  isShow: 1,
                },
              ];
            }
            arrsConddition = [
              ...gdates,
              ...datas.filter((n) => {
                return n.textBoxType !== "datetime";
              }),
            ];
          }
        });
      // 获取 每个查询条件 的下拉数据
      arrsConddition.forEach(async (element, index) => {
        let { textBoxType } = element;
        if (textBoxType == "select") {
          element.selectOptions = [];
        }
      });
      this.queryCondditionDatas = arrsConddition;
    },
  },
};
</script>
<style scoped lang='less'>
// 查询条件边框线
@borderColor: #cccccc;
.infoDiv {
  margin-bottom: 20px;
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
.textArea {
  height: auto !important;
}
.goodg {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}
.btnsform {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>